import { render, staticRenderFns } from "./FormRatingIcon.vue?vue&type=template&id=59b30dac&"
import script from "./FormRatingIcon.vue?vue&type=script&lang=js&"
export * from "./FormRatingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports